import React, { useEffect, useState, useContext } from 'react';
import { ButtonComp } from 'atoms/Buttons';
import { useSelector, useDispatch } from 'react-redux';
import ImageComponent from 'atoms/Image';
import FavoriteFillImage from 'styles/staticAssets/images/favorite-filled.svg';
import { AnchorWithLink } from 'atoms/Anchor';
import { UserOrderContext } from '../../../../context/context';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import ADDRESS_STORE_CONSTANTS from './constant';
import { parseInvalidDateAndFormat } from 'common/utilities/dayJsUtils';
import { getFacilities } from 'common/utilities/amenities';
import { setUserParams } from '@kfc-global/react-shared/redux/Actions/AppStateAction';
import { createBasketsAction, qrCodeScanTimeAction } from '@kfc-global/react-shared/redux/Actions/CartAction';
import MyMapComponent from '../../../SearchStore/Presentation/MapComponent';
import ListImage from 'styles/staticAssets/images/Union.svg';
import {
  setOrderNowAnalyticsData,
  setOrderLaterAnalyticsData,
  getChannels, 
  checkTodayDay
} from '../../../SearchStore/SearchStoreUtilities/SearchStoreUtils';
import { getList } from '../../../ScheduleOrder/ScheduleOrderUtils/ScheduleOrderUtils';
import { setLocalisationFinishAnalyticsData } from 'common/utilities/analyticsUtils';
import SEARCH_STORE_CONSTANTS from '../../../SearchStore/Constants/SearchStoreConstants';
import GreenTickImage from 'styles/staticAssets/images/GREEN_RIGHT_TICK.svg';
import START_ORDER_CONSTANTS from '../../../StartOrderComponent/Constants/startOrderConstants';
import {
  isEmptyEvery,
  getValueOrDefaultObject,
  createBasketData,
  getDispositionTypeOnAPIFormat,
  getValueOrDefaultAlternativeObject,
  getAndCheck,
  getTernaryValue,
} from 'common/utilities/utils';
const FavoriteStoresView = props => {
  const { favouriteStores, removeFromFavoriteHandler, history, isMobile } = props;
  const dispatch = useDispatch();
  const [showMap, setShowMap] = useState(false);
  const [showCard, setShowCard] = useState(false);
  const [latLongValues, setLatLongValues] = useState({});
  const [centerIndex, setCenterIndex] = useState(0);
  const [storeCardHeight,] = useState(325);
  const [selectedStore, setSelectedStore] = useState(null);
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);

  const dispositionNew = isEmptyEvery(userOrderState.dispositionNew)
    ? JSON.parse(localStorage.getItem('dispositionNew'))
    : userOrderState.dispositionNew;
  const { BROWSE_MENU, STORE_STATUS_CLOSED, PICK_UP, TAKE_AWAY, LIST_TEXT, STORE_STATUS_CLOSED_CAPS } =
    SEARCH_STORE_CONSTANTS;
  const {
    SCHEDULE_ORDER_DATA,
    SEARCH_ORDER_DATA,
    SELECTED_TILE_DATA,
    MENU_URL,
    SET_DISPOSITION,
    USER_LOCALIZED,
    DISPOSITION_DATA,
    SCHEDULE_ORDER_TIME_DATA,
    CURRENT_STORE_INFO,
  } = START_ORDER_CONSTANTS;
  const { DEFAULT_DISPOSITION_TAKEWAY, mapText } = ADDRESS_STORE_CONSTANTS;
  let userParams = useSelector(data => data.appStateReducer.userStatus);
  const profileReducer = useSelector(data => data.profileReducer);
  const tenantReducer = useSelector(data => data.tenantReducer);
  const { componentOptions = {} } = tenantReducer;
  const { allowScheduleOrder } = getValueOrDefaultAlternativeObject(componentOptions?.ScheduledDeliveryComponent, true);

  const getFullAddressDetails = addresses =>
    `${addresses.addressLines.join(' ')} ${addresses.city} ${addresses.state} ${addresses.country} ${
      addresses.pinCode
    }`;

  const timimgMsg = item => {
    const storeStatus = item.summary;
    const { operatingHours = [] } = getTernaryValue(storeStatus?.timings?.operatingHours, storeStatus?.timings, []);
    return checkTodayDay(item.isOpen, operatingHours);
  };

  const showAvailableService = (channels = []) => {
    const webChannel = channels && getChannels(channels);
    const { services: orderTypes = [] } = getValueOrDefaultAlternativeObject(webChannel[0], []);
    return orderTypes.map((item, index) => {
      return (
        <div className='store-order-options' key={index}>
          <span>
            <ImageComponent data-testid='' srcFile={GreenTickImage} alt={'tick'} className='tick-image' />
          </span>
          <span>{getTernaryValue(item === PICK_UP, translateWithI18Next(TAKE_AWAY), item)}</span>
        </div>
      );
    });
  };

  const setUserParamsInfo = () => {
    dispatch(
      setUserParams({
        ...userParams,
        localized: true,
      }),
    );
  };

  /** redirect to menu page function */
  const gotoMenuPageBrowse = selectedStoreInfo => {
    let store = getModifiedStore(selectedStoreInfo);
    const payload = {
      storeID: store?.id,
      disposition: DEFAULT_DISPOSITION_TAKEWAY,
      postCode: store?.addresses[0]?.address?.pinCode,
    };
    setLocalisationFinishAnalyticsData(payload);
    localStorage.setItem('currentStoreInfo', JSON.stringify(store));
    currentStoresInfo();
    setUserParamsInfo();
    userOrderStateDispatch({
      type: SET_DISPOSITION,
      value: {
        oldvalue: dispositionNew,
        newValue: {
          type: DEFAULT_DISPOSITION_TAKEWAY,
          store,
          date: '',
          time: '',
          interval: '',
          deliveryAddress: '',
        },
      },
    });
    localStorage.setItem('dispositionOld', JSON.stringify(dispositionNew));
    localStorage.setItem(
      'dispositionNew',
      JSON.stringify({
        type: DEFAULT_DISPOSITION_TAKEWAY,
        store,
        date: '',
        time: '',
        interval: '',
        deliveryAddress: '',
      }),
    );

    userOrderStateDispatch({ type: DISPOSITION_DATA, value: { showDisposition: false } });
    searchOrderData();
    history.push({
      pathname: `${MENU_URL}`,
    });
  };

  const searchOrderData = () => {
    userOrderStateDispatch({ type: SEARCH_ORDER_DATA, value: { showSearchStore: false } });
  };

  const getModifiedStore = selectedStoreInfo => {
    selectedStoreInfo['additionalProperties'] = selectedStoreInfo['storeBasic']['additionalProperties'];
    selectedStoreInfo['addresses'] = selectedStoreInfo['storeBasic']['address'];
    selectedStoreInfo['amenities'] = selectedStoreInfo['storeBasic']['amenities'];
    selectedStoreInfo['name'] = selectedStoreInfo['storeBasic']['dname'];
    selectedStoreInfo['id'] = selectedStoreInfo['storeBasic']['id'];
    selectedStoreInfo['location'] = selectedStoreInfo['storeBasic']['location'];
    selectedStoreInfo['service'] = selectedStoreInfo['storeBasic']['service'];
    return selectedStoreInfo;
  };

  const currentStoresInfo = store => {
    userOrderStateDispatch({
      type: CURRENT_STORE_INFO,
      value: store,
    });
  };

  /* redirect to menu page function */
  const gotoMenuPage = (storeInfoObj, dateTimeObj) => {
    let store = storeInfoObj;
    selectedTileData();
    // update currently selected store info
    localStorage.setItem('currentStoreInfo', JSON.stringify(store));
    currentStoresInfo(store);
    setUserParamsInfo();
    userOrderStateDispatch({
      type: SCHEDULE_ORDER_TIME_DATA,
      value: { selectedDateTime: dateTimeObj },
    });

    localStorage.setItem('tenantReducer', JSON.stringify(tenantReducer));
    localStorage.setItem('selectedTile', JSON.stringify({}));
    localStorage.setItem('dispositionType', DEFAULT_DISPOSITION_TAKEWAY);
    localStorage.setItem('storeInfo', JSON.stringify(store));
    localStorage.setItem('dateTimeOrder', JSON.stringify(dateTimeObj));
    props.history.push({
      pathname: `${MENU_URL}`,
    });
  };

  /** Method to handle schedule order button click */
  const scheduleOrderButtonClickHandler = (e, selectedStoreInfo) => {
    e.preventDefault();
    e.stopPropagation();
    localStorage.removeItem('renderComp');
    localStorage.removeItem('setFav');
    localStorage.setItem('dispositionType', DEFAULT_DISPOSITION_TAKEWAY);
    selectedStoreInfo = getModifiedStore(selectedStoreInfo);
    userLocalised();

    userOrderStateDispatch({
      type: SCHEDULE_ORDER_DATA,
      value: { showScheduleOrderCatering: true, selectedStoreInfo: selectedStoreInfo, isAddressFlow: true },
    });

    userOrderStateDispatch({
      type: SEARCH_ORDER_DATA,
      value: { showSearchStore: false },
    });
    const payload = {
      storeID: selectedStoreInfo?.id,
      disposition: DEFAULT_DISPOSITION_TAKEWAY,
      postCode: selectedStoreInfo?.addresses[0]?.address?.pinCode,
    };
    setOrderLaterAnalyticsData();
    scheduleOrderDispatches(selectedStoreInfo);
    setLocalisationFinishAnalyticsData(payload);
  };

  const selectedTileData = () => {
    userOrderStateDispatch({ type: SELECTED_TILE_DATA, value: { selectedData: {} } });
  };

  const scheduleOrderDispatches = storeInfoObj => {
    let store = storeInfoObj;
    selectedTileData();
    // update currently selected store info
    localStorage.setItem('currentStoreInfo', JSON.stringify(store));
    currentStoresInfo(store);
  };

  const checkAvailablity = selectedStoreInfo => {
    const {
      futureDates,
      scheduled: initiallyScheduled,
      asap,
    } = getValueOrDefaultObject(selectedStoreInfo?.summary?.timings);
    const { interval: initialInterval = 0, startEndTime = {} } = getValueOrDefaultObject(
      initiallyScheduled?.periods.length && initiallyScheduled.periods[0],
    );
    const { from: initialDayStartTime, to: initialDayEndTime } = getValueOrDefaultObject(startEndTime);
    const { unavailibilities } = getValueOrDefaultObject(initiallyScheduled);

    return getList(
      initialDayStartTime,
      initialDayEndTime,
      initialInterval,
      asap?.isAvailable,
      getAndCheck(futureDates?.length === 1, tenantReducer?.country?.toUpperCase() === 'INDIA'),
      unavailibilities,
    );
  };

  /** Method to handle order now button click */
  const orderNowButtonClickHandler = async (e, selectedStoreInfo) => {
    e.preventDefault();
    e.stopPropagation();
    setOrderNowAnalyticsData();

    /* newly added code for order now logic */
    const { futureDates, scheduled: initiallyScheduled, asap } = selectedStoreInfo?.summary?.timings || {};
    const { interval: initialInterval = 0, startEndTime = {} } =
      ( initiallyScheduled?.periods.length && initiallyScheduled.periods[0] ) || {};
    const { from: initialDayStartTime, to: initialDayEndTime } = startEndTime;

    getList(
      initialDayStartTime,
      initialDayEndTime,
      initialInterval,
      asap?.isAvailable,
      getAndCheck(futureDates.length === 1, tenantReducer?.country === 'INDIA'),
    );

    let dateTimeObj = {
      time: 'ASAP',
      interval: selectedStoreInfo?.summary?.timings.scheduled.periods[0]?.interval,
      date: new Date(),
      selectedTime: 'ASAP',
    };
    selectedStoreInfo = getModifiedStore(selectedStoreInfo);
    if (
      dispositionNew === null ||
      dispositionNew.type !== DEFAULT_DISPOSITION_TAKEWAY ||
      dispositionNew.store.id !== selectedStoreInfo.id ||
      dispositionNew.deliveryAddress !== userOrderState?.scheduleOrderData?.deliveryAddress
    ) {
      let obj = await createBasketData(
        selectedStoreInfo,
        getDispositionTypeOnAPIFormat(DEFAULT_DISPOSITION_TAKEWAY),
        profileReducer.customerId,
        dateTimeObj,
      );
      dispatch(qrCodeScanTimeAction(''));
      dispatch(createBasketsAction({ data: obj, tenantId: tenantReducer.tenantId }));
    }
    gotoMenuPage(selectedStoreInfo, dateTimeObj);
    userOrderStateDispatch({
      type: SET_DISPOSITION,
      value: {
        oldvalue: dispositionNew,
        newValue: {
          type: DEFAULT_DISPOSITION_TAKEWAY,
          store: selectedStoreInfo,
          date: dateTimeObj.date,
          time: dateTimeObj.time,
          interval: dateTimeObj.interval,
          selectedTime: dateTimeObj.selectedTime,
          deliveryAddress: userOrderState?.scheduleOrderData?.deliveryAddress,
        },
      },
    });
    localStorage.setItem('dispositionOld', JSON.stringify(dispositionNew));
    localStorage.setItem(
      'dispositionNew',
      JSON.stringify({
        type: DEFAULT_DISPOSITION_TAKEWAY,
        store: selectedStoreInfo,
        date: dateTimeObj.date,
        time: dateTimeObj.time,
        interval: dateTimeObj.interval,
        selectedTime: dateTimeObj.selectedTime,
        deliveryAddress: userOrderState?.scheduleOrderData?.deliveryAddress,
      }),
    );
    const payload = {
      storeID: selectedStoreInfo?.id,
      disposition: DEFAULT_DISPOSITION_TAKEWAY,
      postCode: selectedStoreInfo?.addresses[0]?.address?.pinCode,
    };
    setLocalisationFinishAnalyticsData(payload);
    searchOrderData();
    userLocalised();
  };

  const userLocalised = () => {
    userOrderStateDispatch({
      type: USER_LOCALIZED,
      value: { isLocalized: true },
    });
  };

  const sortFavoritesStores = favourite_stores => {
    return favourite_stores.sort(function (a, b) {
      if (a.storeBasic?.dname[0].value < b.storeBasic?.dname[0].value) {
        return -1;
      }
      if (a.storeBasic?.dname[0].value > b.storeBasic?.dname[0].value) {
        return 1;
      }
      return 0;
    });
  };

  const toggleMapView = () => {
    setShowMap(!showMap);
    setShowCard(!showMap);
  };

  const setStoreMarker = latLongObj => {
    const filterStoreMarker = favouriteStores.findIndex(
      store =>
        store.storeBasic.location.latitude === latLongObj.lat() &&
        store.storeBasic.location.longitude === latLongObj.lng(),
    );
    if (filterStoreMarker > -1) {
      setCenterIndex(filterStoreMarker);
      setSelectedStore(getValueOrDefaultObject(favouriteStores[filterStoreMarker]));
    }
  };

  useEffect(() => {
    setShowCard(true);
    getLatLongInfo();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [centerIndex, selectedStore]);

  const getLatLongInfo = () => {
    const latLongValue = favouriteStores.map(store => {
      return { lat: store.storeBasic.location.latitude, lng: store.storeBasic.location.longitude };
    });
    setLatLongValues(latLongValue);
  };

  const onPositionChangeHandler = pointer => {
    let index = pointer ? centerIndex + 1 : centerIndex - 1;
    setCenterIndex(index);
    setSelectedStore(getValueOrDefaultObject(favouriteStores[index]));
  };

  const setStoreInfo = (item, index) => {
    setSelectedStore(item);
    setCenterIndex(index);
  };

  const checkToday = item => {
    const dayAvailability = checkAvailablity(item).length;
    return getTernaryValue(dayAvailability, 'Today', 'Tomorrow');
  };

  const storeCard = (item, index, classname) => {
    return (
      <React.Fragment>
        <div className={`bgv-set store-card d-flex flex-dir ${classname}`}>
          <div className='address-block d-flex'>
            <div>
              <div>
                <span className='card-store-name'>{item?.storeBasic?.dname[0].value}</span>
                <span className='store-distance'>{item?.distance?.text}</span>
                {showMap && (
                  <span className='store-index fl-rgt'>{`${centerIndex + 1} of ${favouriteStores.length}`}</span>
                )}
              </div>
              <div className='card-content'>
                <div className='order-items'>{showAvailableService(item?.availableServicesPerChannel)}</div>
                <div className={'w-100'}>
                  <span className='store-address'>{getFullAddressDetails(item?.storeBasic?.address[0].address)}</span>
                  {!showMap && (
                    <span
                      className='map-link'
                      data-testid='map-handler'
                      onClick={() => {
                        setStoreInfo(item, index);
                        toggleMapView();
                        getLatLongInfo();
                      }}
                    >
                      <AnchorWithLink className='card-map-link'>{translateWithI18Next(mapText)}</AnchorWithLink>
                    </span>
                  )}
                </div>
                {item?.summary && item?.isOpen && (
                  <div className={`info-timing ${!item?.isOpen && 'info-timingClosed'}`}>
                    {item?.isOpen ? '' : <span>{translateWithI18Next(STORE_STATUS_CLOSED)}</span>}
                    <span className={`${!item?.isOpen && timimgMsg(item) && 'list-circle'}`}>{timimgMsg(item)}</span>
                  </div>
                )}
                {item?.summary && !item?.isOpen && (
                  <div className='info-timingClosed'>
                    <ul>
                      <li>
                        {item.summary.status?.currentStatus === STORE_STATUS_CLOSED_CAPS ? (
                          <span className='closed-text'>{STORE_STATUS_CLOSED}</span>
                        ) : (
                          ''
                        )}
                      </li>

                      <li>
                        {item.summary?.timings?.scheduled?.unavailibilities?.length > 0 &&
                        parseInvalidDateAndFormat(
                          item.summary?.timings?.scheduled?.unavailibilities[0]?.to,
                          'HH MM',
                          'HH:MM',
                        ) <=
                          parseInvalidDateAndFormat(
                            item.summary?.timings?.operatingHours[0]?.availableHours?.to,
                            'HH MM',
                            'HH:MM',
                          )
                          ? `Open Today ${
                              item.summary?.timings?.scheduled?.unavailibilities[0]?.to &&
                              parseInvalidDateAndFormat(
                                item.summary?.timings?.scheduled?.unavailibilities[0]?.to,
                                'hh mm',
                                'hh:mm a',
                              )
                            }`
                          : `Open ${checkToday(item)} ${
                              item.summary?.timings?.operatingHours[0]?.availableHours?.from &&
                              parseInvalidDateAndFormat(
                                item.summary?.timings?.operatingHours[0]?.availableHours?.from,
                                'hh mm',
                                'hh:mm a',
                              )
                            }`}
                      </li>
                    </ul>
                  </div>
                )}

                <div className='facilities'>
                  {getFacilities(item?.storeBasic)?.length > 0 &&
                    getFacilities(item?.storeBasic).map(itemVal => {
                      return (
                        <ImageComponent
                          key={itemVal.key}
                          data-testid=''
                          srcFile={itemVal.image}
                          alt={getValueOrDefaultAlternativeObject(itemVal.label, '')}
                          className='facility-img'
                          title={itemVal.label}
                        />
                      );
                    })}
                </div>
              </div>
            </div>
            {!showMap && (
              <div className='d-flex flex-dir mt5 flex-dir-pos'>
                <ImageComponent
                  data-testid='favorite-img'
                  srcFile={FavoriteFillImage}
                  alt={'favorite'}
                  className='favorite-img'
                  onClick={() => removeFromFavoriteHandler(item?.storeBasic?.id)}
                />
              </div>
            )}
          </div>
          <div className='button-block align-center d-flex mt-2'>
            {item?.isOpen && allowScheduleOrder && (
              <ButtonComp
                data-testid='schedule-order'
                className={`padding-set wdth-set schedule-pad margin-adjust button ml5 font-bold whiteButton blkBorder search-store-card-btn schedule-order-btn`}
                onClickHandler={e => scheduleOrderButtonClickHandler(e, item)}
              >
                {translateWithI18Next('scheduleOrder')}
              </ButtonComp>
            )}

            {item?.isOpen && (
              <ButtonComp
                data-testid='order-now'
                className={`padding-set wdth-set order-pad ml5 button redButton search-store-card-btn`}
                onClickHandler={e => orderNowButtonClickHandler(e, item)}
              >
                {'Order Now'}
              </ButtonComp>
            )}

            {scheduleClosedStores(item, checkAvailablity, scheduleOrderButtonClickHandler)}
            {getAndCheck(!item?.isOpen, !checkAvailablity(item).length) && (
              <ButtonComp
                className='padding-set wdth-set browse-pad ml5 ml-0 font-bold button whiteButton blkBorder store-card-btn browse-menu-btn'
                data-testid='browser-menu-closed-store'
                onClickHandler={() => gotoMenuPageBrowse(item)}
              >
                {translateWithI18Next(BROWSE_MENU)}
              </ButtonComp>
            )}
          </div>
        </div>
      </React.Fragment>
    );
  };

  const favStoreCard = sortFavoritesStores(favouriteStores).map((item, index) => {
    return storeCard(item, index);
  });

  return (
    <div className='favorite-stores-section'>
      {favouriteStores.length > 0 && (
        <div className='header-text'>
          My Favorite Stores ({favouriteStores.length})
          {showMap && (
            <span
              data-testid='list-handler'
              onClick={() => {
                toggleMapView();
                getLatLongInfo();
              }}
            >
              <AnchorWithLink className='map-link-list'>
                <span>
                  <ImageComponent data-testid='' srcFile={ListImage} alt={'map'} className='map-img' />
                </span>
                {translateWithI18Next(LIST_TEXT)}
              </AnchorWithLink>
            </span>
          )}
        </div>
      )}
      {favouriteStores.length > 0 && !showMap > 0 && favStoreCard}
      {showMap && (
        <>
          <div className={`takeawayDineInMap delivery-map`}>
            <>
              <MyMapComponent
                data-testid='mymap-id'
                latLongValue={latLongValues}
                loadingElement={<div style={{ height: `100%` }} />}
                containerElement={<div style={{ height: `400px` }} />}
                mapElement={<div style={{ height: `100%` }} />}
                // passAddress={passAddress}
                isVisible={true}
                isMobile={isMobile}
                centerIndex={centerIndex}
                onPositionChangeHandler={onPositionChangeHandler}
                setShowCard={setShowCard}
                setStoreMarker={setStoreMarker}
                storeCardHeight={storeCardHeight}
              />
              {showCard && selectedStore && isMobile ? storeCard(selectedStore, '', 'Selected-mobile-Card') : null}
            </>
            {showCard && selectedStore && !isMobile ? storeCard(selectedStore, '', 'Selected-desktop-Card') : null}
          </div>
        </>
      )}
    </div>
  );
};
export default FavoriteStoresView;

function scheduleClosedStores(item, checkAvailablity, scheduleOrderButtonClickHandler) {
  return (
    <>
      {getAndCheck(!item?.isOpen, checkAvailablity(item).length > 0) && (
        <ButtonComp
          data-testid='closed-order'
          className={`padding-set wdth-set schedule-pad margin-adjust button ml5 font-bold whiteButton blkBorder search-store-card-btn schedule-order-btn`}
          onClickHandler={e => scheduleOrderButtonClickHandler(e, item)}
        >
          {translateWithI18Next('scheduleOrder')}
        </ButtonComp>
      )}
    </>
  );
}
